<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-shadow-1">
                <h5>Autorização de Suporte</h5>
                <hr>
                <div class="p-fluid p-formgrid p-grid">                     
                    <div class="p-field p-col-12 p-md-5">
                        <label>Cliente</label>
                        <Dropdown v-model="idEmpresaSelecionada" :options="empresas" dataKey="id" 
								optionLabel="nome" optionValue="id" placeholder="Selecione" :filter="true" 
                                :showClear="true"/>
                    </div> 
                    <div class="p-field p-col-12 p-md-2">
                        <label>Data</label>
                        <Calendar v-model="mesAno" view="month" dateFormat="mm/yy" :showIcon="true" :manualInput="false" 
                            :yearNavigator="true" :yearRange="rangeData" :locale="localeCalendarBR"/>
                    </div>   
                    <div class="p-field p-col-0">
                        <Button label="Atualizar" icon="pi pi-refresh" style="margin-top: 26px;" @click="listar"/>         
                    </div>    
                </div>
                <DataTable :value="autorizações" :filters="filtro" :paginator="true" :rows="10"
					paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
					:rowsPerPageOptions="[10,20,30,50]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
					class="p-datatable-sm p-datatable-striped">
					<template #header>
						<div class="table-header">			
							<div class="p-d-flex p-jc-end">	                                		
								<span class="p-input-icon-left">
									<i class="pi pi-search" />
									<InputText v-model="filtro['global']" placeholder="Filtrar..." />
								</span>
							</div>
						</div>
					</template>                    
					<Column field="autorizaPor" header="Autorizado Por" sortable></Column>
					<Column field="email" header="E-mail" sortable></Column>
                    <Column field="dataCadastro" header="Data Cadastro" sortable>
                        <template #body="slotProps">
                            {{ formatarData(slotProps.data.dataCadastro) }}
                        </template>
                    </Column>
                    <Column field="dataFinal" header="Data Final" sortable>
                        <template #body="slotProps">
                            {{ formatarData(slotProps.data.dataFinal) }}
                        </template>
                    </Column>
					<Column field="fechado" header="Fechado" sortable>
                        <template #body="slotProps">
                            <label v-if="slotProps.data.fechado">Sim</label>
                            <label v-else>Não</label>
                        </template>
                    </Column>
                    <Column>
						<template #body="slotProps">
							<Button icon="pi pi-external-link" title="Acessar" class="p-button-rounded p-mr-2" 
                            @click="confirmarAcesso(slotProps.data)" v-if="!slotProps.data.fechado"/>
                            <Button icon="pi pi-times" title="Fechar Suporte" class="p-button-rounded p-button-danger" 
                            @click="confirmarFechar(slotProps.data)" v-if="!slotProps.data.fechado"/>							
						</template>
					</Column>                    
				</DataTable>
            </div>
        </div>

        <Dialog :visible.sync="exibirDialogConfirmarFechar" header="Confirmar" :modal="true" :style="{width: '450px'}" @hide="exibirDialogConfirmarFechar=false">
			<div class="confirmation-content" v-if="autorizacaoFechar">
				<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
				<span>Fechar Autorização?</span><br/><br/>
				<label><b>Data Cadastro</b>: {{ formatarData(autorizacaoFechar.dataCadastro) }}</label><br/>
                <label><b>Data Final</b>: {{ formatarData(autorizacaoFechar.dataFinal) }}</label><br/>				
			</div>
			<template #footer>
				<Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogConfirmarExcluir=false"/>
				<Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="fecharSuporte" />
			</template>
		</Dialog>

    </div>
</template>

<script>
import AutorizacaoSuporteService from '@/service/AutorizacaoSuporteService';
import EmpresaService from '@/service/EmpresaService';
import { exibirMensagem, exibirMensagemSis, localeCalendarBR } from '@/global';
import { mapGetters } from 'vuex';

export default {
    autorizacaoSuporteService: null,
    empresaService: null,
    data() {
        return {               
            exibirDialogConfirmarFechar: false,
            idEmpresaSelecionada: null,
            empresas: [],
            autorizações: [],
            autorizacaoFechar: null,
            filtro: {},
            mesAno: new Date(),
            localeCalendarBR: localeCalendarBR
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),
        /**
         * 
         */
        salvar() {
            let requisicao = {				
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}
			this.autorizacaoSuporteService.salvar(requisicao)
			.then(resp => {	
				exibirMensagem(this, resp);	
                this.exibirDialogConfirmarNovo = false;			
				this.listar();							
			})
			.catch(erro => {exibirMensagem(this, erro)});
        },    
        /**
         * 
         */        
        listar() {              
            let mes = this.mesAno.getMonth()+1;
            let ano = this.mesAno.getFullYear();      
            let idEmpresa = this.idEmpresaSelecionada;
			this.autorizacaoSuporteService.listar(idEmpresa, ano, mes)
			.then(resp => {	               
				this.autorizações = resp.data;							
			})
			.catch(erro => {exibirMensagem(this, erro)}); 
        },
        /**
         * 
         */
        listarEmpresas(){
			let requisicao = {                   
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
			this.empresaService.listar(requisicao)
            .then(resp => {			
                this.empresas = resp.data;
                this.idEmpresaSelecionada = this.empresas[0].id;	               			
            })
            .catch(erro => {exibirMensagem(this, erro)});
		},
        /**
         * 
         */
        fecharSuporte() {
            let requisicao = {               
                idSuporte: this.autorizacaoFechar.id
            }
            this.autorizacaoSuporteService.fecharSuporte(requisicao)
			.then(() => {	               
                this.exibirDialogConfirmarFechar = false;
                exibirMensagemSis(this, "Sucesso", false);
                this.listar();
			})
			.catch(erro => {exibirMensagem(this, erro)}); 
        },
        /**
         * 
         */
        confirmarFechar(data) {
            this.autorizacaoFechar = data;
            this.exibirDialogConfirmarFechar = true;
        },
        /**
         * 
         * @param {*} data 
         */
        confirmarAcesso(data) {
            let requisicao = {               
                idAutorizacao: data.id
            }
            this.autorizacaoSuporteService.atualizarRefAcessoSuporte(requisicao)
			.then(resp => {	               
				let refAcesso = resp.data.refAcesso;
                let url = process.env.VUE_APP_BASE_URL_FRONTEND_IKPONTO+'?_ref='+data.id+'&_aut='+data.autorizacao+'&_refacesso='+refAcesso;	
                window.open(url, '_blank');				
			})
			.catch(erro => {exibirMensagem(this, erro)});              
        },
        /**
         * 
         */
         criarRangeData() {
            let anoAtual = new Date().getFullYear();     
            this.rangeData = (anoAtual-10)+':'+(anoAtual+20);     
        },
        /**
         * 
         * @param {*} strData 
         */
        formatarData(strData) {
           if(strData) {
            let strDataHora = strData.split(' ');
            let partesData = strDataHora[0].split('-');           
            let dataFormat = partesData[2] + '/' + partesData[1] + '/' + partesData[0];          
            if(strDataHora.length > 1) {
                dataFormat  += ' ' + strDataHora[1];
            }
            return dataFormat;
           } else {
               return '';
           }
        }   
    },
    created() {
        this.autorizacaoSuporteService = new AutorizacaoSuporteService();
        this.empresaService = new EmpresaService();
    },
    mounted() { 
        this.criarRangeData();       
        this.listarEmpresas();
    }
}
</script>

<style>

</style>